import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { FormControl, MenuItem, Select, Typography } from '@material-ui/core';
import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';
import { SITE_LOGO_URL_MAPPING } from 'config/Sites/logoUrl';
import { redirectBySite } from 'config/routing';
import { useAllowedSites, useSiteConfig } from 'libs/common/hooks';
import client from 'services/networking/client';
import { Chevron } from 'theme/icons';
import { IconContainer, ItemContainer, SiteLogo } from './SelectSite.style';

var SelectSite = function SelectSite() {
  var _useSiteConfig = useSiteConfig(),
      site = _useSiteConfig.id;

  var _useRouter = useRouter(),
      push = _useRouter.push,
      route = _useRouter.route;

  useEffect(function () {
    return client.setSite(site);
  }, [site]);
  var handleSiteChange = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(selectSite) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return push(redirectBySite(selectSite, route));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [push, route]);
  var allowedSites = useAllowedSites();
  return __jsx(FormControl, {
    variant: "outlined"
  }, __jsx(Select, {
    value: site,
    onChange: function onChange(event) {
      return handleSiteChange(event.target.value);
    },
    IconComponent: Chevron,
    style: {
      width: '200px'
    },
    color: "primary",
    disabled: allowedSites.length < 2 && allowedSites.some(function (siteConfig) {
      return siteConfig.id === site;
    })
  }, allowedSites.map(function (_ref2) {
    var siteId = _ref2.id,
        label = _ref2.label;
    return __jsx(MenuItem, {
      key: siteId,
      value: siteId
    }, __jsx(ItemContainer, null, __jsx(IconContainer, null, __jsx(SiteLogo, {
      src: SITE_LOGO_URL_MAPPING[siteId]
    })), __jsx(Typography, {
      variant: "inherit"
    }, label)));
  })));
};

export default SelectSite;